// extracted by mini-css-extract-plugin
export default {"container":"panel_container__QhaNC","header":"panel_header__l2GpF","title":"panel_title__qzlvL","titleTooltip":"panel_titleTooltip__Zr87P"};